import React, { createContext, useState, useEffect } from "react";

export const NameContext = createContext(null);

export const NameProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);

  const [name, setName] = useState("");
  const [name2, setName2] = useState("");

  const [isNameEntered, setIsNameEntered] = useState(false);
  const [showAlternateMessage, setShowAlternateMessage] = useState(false);
  const [nameColor, setNameColor] = useState("#ec4899");
  const [showFormDirectly, setShowFormDirectly] = useState(false);

  // Initial: Werte aus localStorage holen
  useEffect(() => {
    const storedName = localStorage.getItem("userName");
    const storedName2 = localStorage.getItem("userName2");

    const normalizedName = storedName === "Demo" ? "..." : storedName;
    setName(normalizedName || "...");
    setName2(storedName2 || "");

    const storedIsNameEntered = localStorage.getItem("isNameEntered");

    // Neuer User (kein localStorage) -> automatisch "eingeloggt"
    setIsNameEntered(storedName !== null ? storedIsNameEntered === "true" : true);

    setNameColor(localStorage.getItem("nameColor") || "#ec4899");

    setIsLoading(false);
  }, []);

  // Nach Änderungen: Werte speichern
  useEffect(() => {
    if (isLoading) return;
    localStorage.setItem("userName", name);
  }, [name, isLoading]);

  useEffect(() => {
    if (isLoading) return;
    localStorage.setItem("userName2", name2);
  }, [name2, isLoading]);

  useEffect(() => {
    if (isLoading) return;
    localStorage.setItem("isNameEntered", String(isNameEntered));
  }, [isNameEntered, isLoading]);

  useEffect(() => {
    if (isLoading) return;
    localStorage.setItem("nameColor", nameColor);
  }, [nameColor, isLoading]);

  const forceNameEntry = () => setIsNameEntered(false);

  const showNameForm = (callback) => {
    setShowFormDirectly(true);
    if (callback) callback();
  };

  const closeNameForm = () => setShowFormDirectly(false);

  const handleNoThanks = () => {
    setName("...");
    setName2("Hamburg");
    setIsNameEntered(true);
  };

  return (
    <NameContext.Provider
      value={{
        name,
        setName,
        name2,
        setName2,

        isNameEntered,
        setIsNameEntered,

        showAlternateMessage,
        setShowAlternateMessage,

        nameColor,
        setNameColor,

        showFormDirectly,
        setShowFormDirectly,

        forceNameEntry,
        showNameForm,
        closeNameForm,
        handleNoThanks,

        isLoading,
      }}
    >
      {!isLoading && children}
    </NameContext.Provider>
  );
};
